var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import React from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import styled from 'styled-components'
import { ODButton, ODButtonTheme } from '../../misc'
import { ODModal } from '../base/ODModal'
import { ODModalBody } from '../base/ODModalBody'
import { ODModalFooter } from '../base/ODModalFooter'
import { ODModalHeader } from '../base/ODModalHeader'
var SelectWrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  display: flex;\n  padding-top: 5px;\n  padding-bottom: 10px;\n'],
      ['\n  display: flex;\n  padding-top: 5px;\n  padding-bottom: 10px;\n']
    ))
)
var SelectableItemTitle = styled.div(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      [
        '\n  height: 20px;\n  font-size: 14px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  padding-top: 4px;\n  margin-bottom: 14px;\n  color: #2e343a;\n',
      ],
      [
        '\n  height: 20px;\n  font-size: 14px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  padding-top: 4px;\n  margin-bottom: 14px;\n  color: #2e343a;\n',
      ]
    ))
)
var SelectableItemDescription = styled.div(
  templateObject_3 ||
    (templateObject_3 = __makeTemplateObject(
      [
        '\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #2f353a;\n',
      ],
      [
        '\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #2f353a;\n',
      ]
    ))
)
function SelectableItem(_a) {
  var onClick = _a.onClick,
    index = _a.index,
    selectedValue = _a.selectedValue,
    option = _a.option
  var name = 'option_' + index
  return React.createElement(
    SelectWrapper,
    {
      onClick: function () {
        return onClick(option.value)
      },
    },
    React.createElement(
      FormGroup,
      { check: true, className: 'radio' },
      React.createElement(Input, {
        className: 'form-check-input',
        type: 'radio',
        id: name,
        name: 'radios',
        value: name,
        checked: selectedValue === option.value,
        onChange: function () {
          return onClick(option.value)
        },
      }),
      React.createElement(
        Label,
        { check: true, className: 'form-check-label', htmlFor: name },
        React.createElement(SelectableItemTitle, null, option.title),
        option.description && React.createElement(SelectableItemDescription, null, option.description)
      )
    )
  )
}
var SelectsWrapper = styled.div(
  templateObject_4 ||
    (templateObject_4 = __makeTemplateObject(
      ['\n  display: flex;\n  flex-direction: column;\n'],
      ['\n  display: flex;\n  flex-direction: column;\n']
    ))
)
export function useModalSelect(options) {
  var title = options.title,
    selects = options.selects,
    _a = options.okTitle,
    okTitle = _a === void 0 ? 'Ok' : _a
  var _b = React.useState(false),
    isOpen = _b[0],
    setIsOpen = _b[1]
  var _c = React.useState(null),
    selectedValue = _c[0],
    setSelectedValue = _c[1]
  var onClickYes = React.useRef(function () {
    return undefined
  })
  var onClickNo = React.useRef(function () {
    return undefined
  })
  var selectedValueRef = React.useRef(null)
  var choose = React.useCallback(function (initialValue) {
    return new Promise(function (resolve) {
      setSelectedValue(initialValue)
      selectedValueRef.current = initialValue
      onClickYes.current = function () {
        setIsOpen(false)
        resolve(selectedValueRef.current)
      }
      onClickNo.current = function () {
        setIsOpen(false)
        resolve(null)
      }
      setIsOpen(true)
    })
  }, [])
  var Component = React.useState(function () {
    return function (props) {
      return React.createElement(
        ODModal,
        {
          isOpen: props.isOpen,
          toggle: function () {
            return onClickNo.current()
          },
        },
        React.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column' } },
          React.createElement(ODModalHeader, {
            title: title,
            onClose: function () {
              return onClickNo.current()
            },
          }),
          React.createElement(
            ODModalBody,
            null,
            React.createElement(
              SelectsWrapper,
              null,
              selects.map(function (select, index) {
                return React.createElement(SelectableItem, {
                  key: index,
                  option: select,
                  index: index,
                  selectedValue: props.selectedValue,
                  onClick: function (v) {
                    setSelectedValue(v)
                    selectedValueRef.current = v
                  },
                })
              })
            )
          ),
          React.createElement(
            ODModalFooter,
            null,
            React.createElement(
              ODButton,
              {
                fullWidth: true,
                theme: ODButtonTheme.Primary,
                onClick: function () {
                  return onClickYes.current()
                },
              },
              okTitle
            )
          )
        )
      )
    }
  })[0]
  return { Component: Component, choose: choose, props: { isOpen: isOpen, selectedValue: selectedValue } }
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4
//# sourceMappingURL=ODModalSelector.js.map
